import { useMutation } from "react-query";
import { useIvideon } from "./useIvideon";
import { createTariffIProps } from "../model/schema";

interface MutateOptions {
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: createTariffIProps;
  options?: MutateOptions;
}

export const useCreateTariff = () => {
  const { createTariff } = useIvideon();

  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await createTariff(props.data);
      if (result.data) {
        return result.data;
      } else {
        throw new Error("Не удалось сохранить договор");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.(data);
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });

  const create = (data: createTariffIProps, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };

  return { create };
};
